import {Validator} from '@/type/validation/result';
import { 必須入力, 日付書式 } from '@/type/validation/validator';

export enum 依頼ステータス区分型 {
  依頼中_手動更新 = '依頼中_手動更新',
  依頼中_自動更新 = '依頼中_自動更新',
  完了 = '完了',
  エラー = 'エラー',
}

export interface 納品データ受信依頼型 {
  依頼日From: Date;
  依頼日To: Date | null;
  依頼ステータス区分: 依頼ステータス区分型 | null;
}

export interface 納品データ受信結果型 {
  納品依頼一覧: 納品データ受信型[];
  アラートメッセージ: string;
}

export interface 納品データ受信型 {
  依頼日時: Date;
  納品番号: number | null;
  受信日: Date | null;
  受信日時: Date | null;
  依頼ステータス区分: 依頼ステータス区分型;
  受信エラーメッセージ: string | null;
}

export enum 卸伝票区分型 {
  入庫 = '入庫',
  返品 = '返品',
}

export enum 作成フラグ型 {
  完了 = '完了',
  未完了 = '未完了',
}

export enum 入庫済区分型 {
  入庫済 = '入庫済',
  未入庫 = '未入庫',
}

export interface 納品伝票型 {
  納品番号: number;
  卸コード: string;
  卸名: string;
  卸伝票区分: 卸伝票区分型;
  卸伝票番号: string;
  卸伝票日: Date;
  伝票明細件数: number;
  完了区分: string;
}

export interface 納品伝票明細一覧取得依頼型 {
  納品番号: number;
  卸伝票区分: 卸伝票区分型;
  卸コード: string;
  卸伝票番号: string;
  卸伝票日: Date;
}

export interface 納品伝票明細型 {
  卸伝票番号行: number;
  納品商品名: string;
  納品数: number;
  納品単価: number;
  納品合計金額: number;
  税率対象品目区分: string;
  ロット番号: string;
  有効期限: Date;
  税率区分基準日: number;
  入庫済区分: string;
}

export const  納品データ受信依頼バリデータ一覧: Validator[] = [
  {
      name: '依頼日From',
      constraints: [
        {method: 必須入力, message: '依頼日Fromは入力が必要です'},
        {method: 日付書式, message: '依頼日Fromの書式が不正です'},
      ],
  },
  {
      name: '依頼日To',
      constraints: [
        {method: 日付書式, message: '依頼日Toの書式が不正です'},
      ],
  },
];
